"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validators = exports.url = exports.required = exports.number = exports.minDate = exports.min = exports.max = exports.isValidePhone = exports.isPositive = exports.equal = exports.email = exports.accept = void 0;
var _react = _interopRequireDefault(require("react"));
var yup = _interopRequireWildcard(require("yup"));
var _libphonenumberJs = require("libphonenumber-js");
var _Translations = require("../Translations");
var _lodash = _interopRequireDefault(require("lodash"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * @description Validates the value as an email address
 * @param {string} errorMsg
 */
var email = function email(errorMsg) {
  return function (value) {
    if (!yup.string().email().isValidSync(value)) {
      return /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: errorMsg ? errorMsg : 'Email invalide.'
      });
    }
  };
};

/**
 * @description Validates the value of a field without ","
 * @param {string} errorMsg
 */
exports.email = email;
var number = function number(errorMsg) {
  return function (value) {
    if (!yup.number().isValidSync(value) && value !== null) {
      return /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: errorMsg ? errorMsg : 'Le nombre indiqué est invalide.'
      });
    }
  };
};

/**
 * @description All field values apart from undefined and null meet this requirement
 * @param {string} errorMsg
 */
exports.number = number;
var required = function required(errorMsg) {
  return function (value) {
    if (!yup.string().required().isValidSync(value)) {
      return /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: errorMsg ? errorMsg : 'Ce champ est obligatoire.'
      });
    }
  };
};

/**
 * @description Set a minimum length limit for the string value
 * @param {number} length
 * @param {string} errorMsg
 */
exports.required = required;
var min = function min(length, errorMsg) {
  return function (value) {
    if (!yup.string().min(length).isValidSync(value)) {
      return errorMsg ? /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: errorMsg
      }) : 'Caractères maximum ' + length;
    }
  };
};

/**
 * @description Set a maximum length limit for the string value
 * @param {number} length
 * @param {string} errorMsg
 */
exports.min = min;
var max = function max(length, errorMsg) {
  return function (value) {
    if (!yup.string().max(length).isValidSync(value)) {
      return errorMsg ? /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: errorMsg
      }) : 'Caractères maximum ' + length;
    }
  };
};

/**
 * @description Validates the value as a boolean
 * @param {string} errorMsg
 */
exports.max = max;
var accept = function accept(errorMsg) {
  return function (value) {
    if (!yup.boolean().isValidSync(value) || value === false) {
      return /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: errorMsg ? errorMsg : "Il faut accepter les conditions"
      });
    }
  };
};

/**
 * @description Validates the value to be a positive number
 * @param {string} errorMsg
 */
exports.accept = accept;
var isPositive = function isPositive(errorMsg) {
  return function (value) {
    if (!yup.number().positive(0).min(0).isValidSync(value) || value === false) {
      return /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: errorMsg ? errorMsg : "Number has to be equal or greater than 0"
      });
    }
  };
};

/**
 * @description Validator that insures that the provided value formValue
 * is equal to the value of the field
 * @param {string} formValue
 * @param {string} errorMsg
 */
exports.isPositive = isPositive;
var equal = function equal(formValue, errorMsg) {
  return function (value) {
    var isValid = yup.string().test('equal', function (v) {
      return v === formValue;
    }).isValidSync(value);
    if (!isValid) {
      return /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: errorMsg ? errorMsg : "values are not equal"
      });
    }
  };
};

/**
 * @description Validates that the value is a url
 * @param {string} errorMsg
 */
exports.equal = equal;
var url = function url(errorMsg) {
  return function (value) {
    if (!yup.string().url().isValidSync(value)) {
      return /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: errorMsg ? errorMsg : "L'url indiqué est invalide."
      });
    }
  };
};

/**
 * @description Checks if the entered date is not equal or smaller than the field's date
 * @param {object} minDateObject
 * @param {string} errorMsg
 */
exports.url = url;
var minDate = function minDate(minDateObject, errorMsg) {
  return function (value) {
    if (!yup.date().min(minDateObject).isValidSync(value)) {
      return /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: errorMsg ? errorMsg : 'La date doit être postérieure à la date du jour'
      });
    }
  };
};

/**
 * @description check if the phone number is valid or not
 * @param {*} errorMsg custom error message
 */
exports.minDate = minDate;
var isValidePhone = function isValidePhone(required, errorMsg) {
  return function (value) {
    if (value) {
      if (required && !(0, _libphonenumberJs.isValidPhoneNumber)(value)) {
        return /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: errorMsg ? errorMsg : 'Invalid phone number',
          defaultMessage: errorMsg ? errorMsg : 'Invalid phone number'
        });
      }
      if (!required && value.length > 3 && !(0, _libphonenumberJs.isValidPhoneNumber)(value)) {
        return /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: errorMsg ? errorMsg : 'Invalid phone number',
          defaultMessage: errorMsg ? errorMsg : 'Invalid phone number'
        });
      }
    } else {
      return /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
        id: errorMsg ? errorMsg : 'Invalid phone number',
        defaultMessage: errorMsg ? errorMsg : 'Invalid phone number'
      });
    }
  };
};

// We use this function to use multiple validator
// for example validators([required(), email()])
// we are returned the first error obtained
exports.isValidePhone = isValidePhone;
var validators = function validators() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return function (value) {
    if (!_lodash.default.isArray(items)) {
      throw Error("validators params must be array");
    }
    var _iterator = _createForOfIteratorHelper(items),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        var error = item(value);
        if (error) {
          return error;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
};
exports.validators = validators;